export default "__VITE_ASSET__27bf5d33__"